import { matchPath } from 'react-router-dom'
import { useAppSelector } from 'reduxTyped'

import { getUpgradeRequest } from 'common/billing/entities/upgradeRequest/selectors'
import { RoutePaths } from 'utils/router/constants'

const BLOCKED_PAGES = [
  RoutePaths.REGISTRATION,
  RoutePaths.CHANNEL_CONNECTION,
  RoutePaths.SETTINGS,
  RoutePaths.CMS,
  RoutePaths.CMS_BUILDER,
]

export function usePromptsAllowed() {
  const isUpgradeViewOpen = useAppSelector(getUpgradeRequest)?.isOpen

  const currentPath = window.location.pathname
  const isPageBlocked = BLOCKED_PAGES.some((blockedPath) => matchPath(blockedPath, currentPath))

  if (isPageBlocked || isUpgradeViewOpen) return false

  return true
}
